const bridge_financing_per_yr_list = [
  { value: "1to5", name: "1-5" },
  { value: "6to10", name: "6-10" },
  { value: "11to15", name: "11-15" },
  { value: "16plus", name: "16+" },
];

export default bridge_financing_per_yr_list;



// WEBPACK FOOTER //
// ./src/constants/bridge_financing_per_yr_list.js